// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon__1GF3z","Icon--block":"Icon--block__349Mr","Icon--disablePointerEvent":"Icon--disablePointerEvent__3u6ve","Icon__svg":"Icon__svg__1nGfN"};